import { InvokeCallback, Sender } from "xstate";
import { AccountTypeEnum } from "@api";
import { createAccountWithToken } from "@api/v1/methods/accounts";
import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";
import { investmentTypeToAccountType } from "../utils/utils";

export const persistDepot =
  (
    context: TransactionWizardContext,
    event: TransactionWizardEvent
  ): InvokeCallback<TransactionWizardEvent, TransactionWizardEvent> =>
  (callback) => {
    if (event.type !== "PERSIST_DEPOT")
      throw new Error(`Invalid event type: ${event.type}`);
    if (!context.investmentValues.type)
      throw new Error("Investment type is not defined");

    const type = investmentTypeToAccountType(context.investmentValues.type);
    persist(callback, event.name, type);
  };

const persist = async (
  callback: Sender<TransactionWizardEvent>,
  name: string,
  type: AccountTypeEnum
) => {
  try {
    const account = await createAccountWithToken({
      name: name,
      type: type,
      enableImplicitTransactions: true,
    });
    callback({
      type: "DEPOT_PERSISTED",
      depotId: account.id,
    });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
